import { useSelector } from "react-redux";

import { StoreType } from "../../../utils/types";

// Single read point for the transport slice, mirroring
// use-gat-admin-config-data in the surrounding admin screens.
const useTransportData = () => {
	const busStops = useSelector((state: StoreType) => state.transport.busStops);
	const busStopsLocationId = useSelector(
		(state: StoreType) => state.transport.busStopsLocationId
	);
	const getBusStopsStatus = useSelector(
		(state: StoreType) => state.transport.getBusStops.status
	);
	const getBusStopsErrorMessage = useSelector(
		(state: StoreType) => state.transport.getBusStops.errorMessage
	);
	const createBusStopStatus = useSelector(
		(state: StoreType) => state.transport.createBusStop.status
	);
	const createBusStopErrorMessage = useSelector(
		(state: StoreType) => state.transport.createBusStop.errorMessage
	);
	const renameBusStopStatus = useSelector(
		(state: StoreType) => state.transport.renameBusStop.status
	);
	const renameBusStopErrorMessage = useSelector(
		(state: StoreType) => state.transport.renameBusStop.errorMessage
	);
	const updateBusStopStatusStatus = useSelector(
		(state: StoreType) => state.transport.updateBusStopStatus.status
	);
	const updateBusStopStatusErrorMessage = useSelector(
		(state: StoreType) => state.transport.updateBusStopStatus.errorMessage
	);

	const isTransportEnabledForWorker = useSelector(
		(state: StoreType) => state.transport.isTransportEnabledForWorker
	);
	const shiftTransportOptions = useSelector(
		(state: StoreType) => state.transport.shiftTransportOptions
	);
	const shiftTransportOptionsShiftId = useSelector(
		(state: StoreType) => state.transport.shiftTransportOptionsShiftId
	);
	const getShiftTransportOptionsStatus = useSelector(
		(state: StoreType) => state.transport.getShiftTransportOptions.status
	);
	const myTransportRequests = useSelector(
		(state: StoreType) => state.transport.myTransportRequests
	);
	const getMyTransportRequestsStatus = useSelector(
		(state: StoreType) => state.transport.getMyTransportRequests.status
	);
	const getMyTransportRequestsErrorMessage = useSelector(
		(state: StoreType) => state.transport.getMyTransportRequests.errorMessage
	);
	const cancelMyTransportRequestStatus = useSelector(
		(state: StoreType) => state.transport.cancelMyTransportRequest.status
	);
	const cancelMyTransportRequestErrorMessage = useSelector(
		(state: StoreType) => state.transport.cancelMyTransportRequest.errorMessage
	);
	const cancellingRequestId = useSelector(
		(state: StoreType) => state.transport.cancellingRequestId
	);
	const standaloneTransportOptions = useSelector(
		(state: StoreType) => state.transport.standaloneTransportOptions
	);
	const getStandaloneTransportOptionsStatus = useSelector(
		(state: StoreType) => state.transport.getStandaloneTransportOptions.status
	);
	const getStandaloneTransportOptionsErrorMessage = useSelector(
		(state: StoreType) =>
			state.transport.getStandaloneTransportOptions.errorMessage
	);
	const createTransportRequestStatus = useSelector(
		(state: StoreType) => state.transport.createTransportRequest.status
	);
	const createTransportRequestErrorMessage = useSelector(
		(state: StoreType) => state.transport.createTransportRequest.errorMessage
	);
	const createdRequestCount = useSelector(
		(state: StoreType) => state.transport.createdRequestCount
	);
	const myLocationId = useSelector(
		(state: StoreType) => state.transport.myLocationId
	);
	const myLocationBusStops = useSelector(
		(state: StoreType) => state.transport.myLocationBusStops
	);
	const getMyLocationBusStopsStatus = useSelector(
		(state: StoreType) => state.transport.getMyLocationBusStops.status
	);
	const getMyLocationBusStopsErrorMessage = useSelector(
		(state: StoreType) => state.transport.getMyLocationBusStops.errorMessage
	);
	const myDefaultBusStop = useSelector(
		(state: StoreType) => state.transport.myDefaultBusStop
	);
	const getMyDefaultBusStopStatus = useSelector(
		(state: StoreType) => state.transport.getMyDefaultBusStop.status
	);
	const setMyDefaultBusStopStatus = useSelector(
		(state: StoreType) => state.transport.setMyDefaultBusStop.status
	);
	const setMyDefaultBusStopErrorMessage = useSelector(
		(state: StoreType) => state.transport.setMyDefaultBusStop.errorMessage
	);
	const clearMyDefaultBusStopStatus = useSelector(
		(state: StoreType) => state.transport.clearMyDefaultBusStop.status
	);
	const clearMyDefaultBusStopErrorMessage = useSelector(
		(state: StoreType) => state.transport.clearMyDefaultBusStop.errorMessage
	);
	const transportRequests = useSelector(
		(state: StoreType) => state.transport.transportRequests
	);
	const getTransportRequestsStatus = useSelector(
		(state: StoreType) => state.transport.getTransportRequests.status
	);
	const getTransportRequestsErrorMessage = useSelector(
		(state: StoreType) => state.transport.getTransportRequests.errorMessage
	);
	const transportRequestsForbidden = useSelector(
		(state: StoreType) => state.transport.transportRequestsForbidden
	);
	const actionTransportRequestsStatus = useSelector(
		(state: StoreType) => state.transport.actionTransportRequests.status
	);
	const actionTransportRequestsErrorMessage = useSelector(
		(state: StoreType) => state.transport.actionTransportRequests.errorMessage
	);
	const actionFailures = useSelector(
		(state: StoreType) => state.transport.actionFailures
	);
	const dailyOrder = useSelector(
		(state: StoreType) => state.transport.dailyOrder
	);
	const getDailyOrderStatus = useSelector(
		(state: StoreType) => state.transport.getDailyOrder.status
	);
	const getDailyOrderErrorMessage = useSelector(
		(state: StoreType) => state.transport.getDailyOrder.errorMessage
	);
	const transportLocations = useSelector(
		(state: StoreType) => state.transport.transportLocations
	);
	const getTransportLocationsStatus = useSelector(
		(state: StoreType) => state.transport.getTransportLocations.status
	);

	return {
		busStops,
		busStopsLocationId,
		getBusStopsStatus,
		getBusStopsErrorMessage,
		createBusStopStatus,
		createBusStopErrorMessage,
		renameBusStopStatus,
		renameBusStopErrorMessage,
		updateBusStopStatusStatus,
		updateBusStopStatusErrorMessage,
		isTransportEnabledForWorker,
		shiftTransportOptions,
		shiftTransportOptionsShiftId,
		getShiftTransportOptionsStatus,
		myTransportRequests,
		getMyTransportRequestsStatus,
		getMyTransportRequestsErrorMessage,
		cancelMyTransportRequestStatus,
		cancelMyTransportRequestErrorMessage,
		cancellingRequestId,
		standaloneTransportOptions,
		getStandaloneTransportOptionsStatus,
		getStandaloneTransportOptionsErrorMessage,
		createTransportRequestStatus,
		createTransportRequestErrorMessage,
		createdRequestCount,
		myLocationId,
		myLocationBusStops,
		getMyLocationBusStopsStatus,
		getMyLocationBusStopsErrorMessage,
		myDefaultBusStop,
		getMyDefaultBusStopStatus,
		setMyDefaultBusStopStatus,
		setMyDefaultBusStopErrorMessage,
		clearMyDefaultBusStopStatus,
		clearMyDefaultBusStopErrorMessage,
		transportRequests,
		getTransportRequestsStatus,
		getTransportRequestsErrorMessage,
		transportRequestsForbidden,
		actionTransportRequestsStatus,
		actionTransportRequestsErrorMessage,
		actionFailures,
		dailyOrder,
		getDailyOrderStatus,
		getDailyOrderErrorMessage,
		transportLocations,
		getTransportLocationsStatus,
	};
};

export default useTransportData;
